module.exports = __webpack_public_path__ + "images/4baac9bd37895cc3d5b59a3999ee052a.vector.png";